"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _constants = require("../utils/constants");

var _default = {
  title: 'Images Per Column',
  description: "This option sets the number of images per a column. This option is currently supported only by Grid layout",
  type: _constants.INPUT_TYPES.NUMBER,
  isRelevant: function isRelevant(styleParams) {
    return styleParams.oneRow;
  },
  "default": 1
};
exports["default"] = _default;